function cx(...classNames) {
  return classNames.filter(Boolean).join(' ');
}

function formatPrice(value, currency = 'USD') {
  return value.toLocaleString('en-US', { style: 'currency', currency });
}

const ProductItem = ({ html, hit, components }) => html`
  <a
    href="/products/${hit.handle}"
    rel="noreferrer noopener"
    class="${cx('aa-ItemLink', hit.objectID)}"
  >
    <div class="aa-ItemContent">
      <div class="aa-ItemPicture aa-ItemPicture--loaded">
        <img
          class="lazyautosizes lazyload"
          width="200"
          height="300"
          data-sizes="auto"
          src="${hit.image}"
          data-srcset="${hit.image} 10w,${hit.image} 20w"
          fetchpriority="auto"
          alt="${hit.title}"
          style="object-position: 50.0% 50.0%;"
          sizes="200px"
          srcset="${hit.image} 10w, ${hit.image} 20w"
        />
      </div>
      <div class="aa-ItemContentBody">
        ${hit.brand &&
        html`
          <div class="aa-ItemContentBrand">
            ${components.Highlight({ hit, attribute: 'brand' })}
          </div>
        `}
        <div class="aa-ItemContentTitleWrapper">
          <div class="aa-ItemContentTitle">
            ${components.Highlight({ hit, attribute: 'title' })}
          </div>
        </div>
        <div class="aa-ItemContentPrice">
          <div class="aa-ItemContentPriceCurrent">
            ${formatPrice(hit.price)}
          </div>
        </div>
      </div>
    </div>
  </a>
`;

function debouncePromise(fn, time) {
  let timerId = undefined;

  return function debounced(...args) {
    if (timerId) {
      clearTimeout(timerId);
    }

    return new Promise((resolve) => {
      timerId = setTimeout(() => resolve(fn(...args)), time);
    });
  };
}

const debounced = debouncePromise((items) => Promise.resolve(items), 300);

document.addEventListener('DOMContentLoaded', () => {
  const { autocomplete, getAlgoliaResults } =
    window['@algolia/autocomplete-js'];
  const algoliasearch = window.algoliasearch;
  const { createLocalStorageRecentSearchesPlugin } =
    window['@algolia/autocomplete-plugin-recent-searches'];

  const recentSearchesPlugin = createLocalStorageRecentSearchesPlugin({
    key: 'RECENT_SEARCH',
    limit: 2,
    transformSource({ source }) {
      return {
        ...source,
        getItemUrl({ item }) {
          return `/collections/search-results?q=${item.query}&productListPage=0`;
        },
        templates: {
          item(params) {
            const { item, html } = params;

            return html`<a
              class="aa-ItemLink"
              href="/collections/search-results?q=${item.query}&productListPage=0"
            >
              ${source.templates.item(params).props.children}
            </a>`;
          },
        },
      };
    },
  });

  const searchClient = algoliasearch(
    '1XJQADMP2C',
    '827492316ba99a1c820a1716d1247868'
  );

  // Rotating placeholders
  const keywords = ['Jumpsuit', 'Kimono', 'Overalls', 'Bralette', 'Romper'];

  const rotatePlaceholder = () => {
    const input = document.getElementById('autocomplete-0-input');
    if (input) {
      const index = Math.floor(Date.now() / 5000) % keywords.length;
      input.placeholder = keywords[index];

      if (!input.hasListener) {
        input.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            const query = input.value.trim();
            if (query.length >= 3) {
              window.location.href = `/collections/search-results?&q=${query}&productListPage=0`;
            }
          }
        });
        input.hasListener = true;
      }
    }
  };

  setInterval(rotatePlaceholder, 1000);

  autocomplete({
    container: '#algolia-autocomplete',
    detachedMediaQuery: 'none',
    openOnFocus: true,
    insights: true,
    plugins: [recentSearchesPlugin],
    getSources({ query }) {
      if (query.length < 3)
        return [
          {
            getItems() {
              return [];
            },
            templates: {
              noResults: () => 'No results.',
            },
          },
        ];
      return debounced([
        {
          sourceId: 'products',
          getItems({ setContext }) {
            return getAlgoliaResults({
              searchClient,
              queries: [
                {
                  indexName: 'shopify_products',
                  query,
                  params: {
                    hitsPerPage: 6,
                  },
                },
              ],
              transformResponse({ hits, results }) {
                setContext({ nbProducts: results[0].nbHits });
                return hits;
              },
            });
          },
          getItemUrl: ({ item }) => item.url,
          templates: {
            item: ({ html, item, components }) =>
              ProductItem({ html, hit: item, components }),
            noResults: () => 'No results.',
          },
        },
      ]);
    },
    render({ elements, state, render, html, setQuery, refresh }, root) {
      const { products } = elements;

      if (state.query.length < 3) {
        render(
          html`
            <div class="aa-PanelLayout aa-Panel--scrollable">
              <div class="aa-PanelSections-blank">
                <div class="aa-PanelSection--keywords">
                  <h4>Popular Searches</h4>
                  ${keywords.map(
                    (keyword) =>
                      html`<p
                        onClick="${(event) => {
                          event.stopPropagation();
                          setQuery(keyword);
                          refresh();
                        }}"
                      >
                        ${keyword}
                      </p>`
                  )}
                </div>
              </div>
            </div>
          `,
          root
        );
      } else {
        render(
          html`
            <div class="aa-PanelLayout aa-Panel--scrollable">
              <div class="aa-PanelSections">
                <div class="aa-PanelSection--left"></div>
                <div class="aa-PanelSection--right">
                  <h4>Product suggestions</h4>
                  ${products}
                  <div class="aa-PanelSection--right-bottom">
                    <a
                      href="/collections/search-results?&q=${state.query}&productListPage=0"
                      rel="noreferrer noopener"
                    >
                      See ${state.context.nbProducts} results for
                      "${state.query}" >
                    </a>
                  </div>
                </div>
              </div>
            </div>
          `,
          root
        );
      }
    },
    navigator: {
      navigate({ itemUrl }) {
        window.location.assign(itemUrl);
      },
    },
  });
});
